import { createContext, ReactNode, useContext } from 'react';
import { FileCacheInterface } from './FileCacheInterface';

type FileCacheContextType = {
  fileCache: FileCacheInterface;
};

const FileCacheContext = createContext<FileCacheContextType | undefined>(undefined);

export const FileCacheContextProvider = ({ children, fileCache }: { children: ReactNode; fileCache: FileCacheInterface }) => {
  return <FileCacheContext.Provider value={{ fileCache }}>{children}</FileCacheContext.Provider>;
};

export const useFileCache = (): FileCacheInterface => {
  const context = useContext(FileCacheContext);
  if (!context) {
    throw new Error('useFileCache must be used within a FileCacheContextProvider');
  }
  return context.fileCache;
};
